import * as React from 'react'
import classNames from 'classnames'

import classes from './style.module.scss'

interface ComponentProps {
  children: React.ReactNode
  className?: string
}

export const DottedBackgroundCard: React.FC<ComponentProps> = ({ children, className }) => {
  return <div className={classNames(classes.container, className)}>{children}</div>
}
